import React, { useEffect, useState } from 'react';
import axios from 'axios';
import prettyBytes from 'pretty-bytes';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { v4 as uuid } from 'uuid';

import { IconButton } from '@techchange/components';

import { messages } from '../../i18n';

import { parseFilestackURL } from '../../utils';

import styles from './FileDisplay.module.scss';

const propTypes = {

	/**
	 * The file url.
	 */
	url: PropTypes.string.isRequired,

	/**
	 * Optional callback function to support removing the file.
	 */
	onRemove: PropTypes.func,

};

const FileDisplay = (props) => {

	const { url, onRemove } = props;

	const intl = useIntl();

	const [file, setFile] = useState({
		id: uuid(),
		name: null,
		size: null,
	});

	useEffect(() => {

		if (url) {

			const { policy, signature, handle } = parseFilestackURL(url);

			const params = `policy=${policy}&signature=${signature}`;

			const metaDataUrl = `https://www.filestackapi.com/api/file/${handle}/metadata`;

			axios.get(`${metaDataUrl}?${params}`).then((response) => {

				if (response && response.data) {

					setFile((prev) => ({
						...prev,
						name: response.data.filename,
						size: response.data.size,
					}));

				}

			}).catch((error) => {
				console.error(error);
			});

		}

	}, [url]);

	return (
		<div className={styles['tc-file-display']}>
			{file.name &&
				<a
					className={styles['filename']}
					href={url}
					rel="noopener noreferrer"
					target="_blank"
					title={intl.formatMessage(messages.TC_COMPONENTS_FILE_DISPLAY_HOVER_TITLE_FILE_PREVIEW)}>
					{file.name}
				</a>
			}
			{file.size &&
				<span
					className={styles['filesize']}
					title={intl.formatMessage(messages.TC_COMPONENTS_FILE_DISPLAY_HOVER_TITLE_FILE_SIZE)}>
					{`(${prettyBytes(file.size)})`}
				</span>
			}
			{onRemove &&
				<IconButton
					id={`remove-icon-btn-${file.id}`}
					icon="far fa-xmark fa-lg"
					size="32px"
					title={intl.formatMessage(messages.TC_COMPONENTS_FILE_DISPLAY_HOVER_TITLE_FILE_REMOVE)}
					placement="top"
					tooltip
					onClick={onRemove} />
			}
		</div>
	);

};

FileDisplay.propTypes = propTypes;

export default FileDisplay;
